<template>
  <div class="w-full">
    <div class="h-[152px] animate-pulse rounded-md bg-gray-200" />
  </div>
</template>

<script lang="ts">
import { Vue } from "vue-class-component";

export default class ProfilePageSkeleton extends Vue {}
</script>
